import type { CSSProperties } from 'react';
import { cx } from './ui/cx';
import './BrandStripe.css';

/**
 * Brand set-piece: a carbon (or accent) panel with the slowly-spinning ring
 * mark above the "CONVERTED CLOSET" wordmark. Shared by SignIn (full-height
 * left stripe) and Subscribe (split panel). The parent controls the panel's
 * width/height via layout; `logoSize` overrides the logo scale (a CSS length
 * for `--cc-logo`) so it fits smaller panels.
 */
export function BrandStripe({ logoSize, className }: { logoSize?: string; className?: string }) {
  const style = logoSize ? ({ ['--cc-logo']: logoSize } as CSSProperties) : undefined;
  return (
    <aside className={cx('brand-stripe', className)} style={style} aria-hidden="true">
      <div className="brand-stripe__logo">
        {/* Ring = icon-only mark (centred → clean spin). Wordmark = the real
            "CONVERTED CLOSET" cropped from the full logo, never re-typeset. */}
        <img className="brand-stripe__ring" src="/logos/cc-logo-icon-white.png" alt="" />
        <span className="brand-stripe__wordmark">
          <img src="/logos/cc-logo-full-white.png" alt="" />
        </span>
      </div>
    </aside>
  );
}
